import api from './api';

export interface Feedback {
    id: number;
    name: string;
    message: string;
    rating: number;
    avatar_color: string;
    order_position: number;
    created_at: string;
    updated_at: string;
}

export interface FeedbackCreateRequest {
    name: string;
    message: string;
    rating: number;
    avatar_color?: string;
    order_position?: number;
}

export interface FeedbackUpdateRequest extends FeedbackCreateRequest {
    id: number;
}

class FeedbackService {
    async getAll(): Promise<Feedback[]> {
        try {
            const response = await api.get<{data: Feedback[]}>('/api/feedbacks');
            return response.data || [];
        } catch (error) {
            console.error('Error fetching feedbacks:', error);
            throw error;
        }
    }

    async getById(id: number): Promise<Feedback> {
        try {
            const response = await api.get<{data: Feedback}>(`/api/feedbacks/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching feedback:', error);
            throw error;
        }
    }

    async create(feedback: FeedbackCreateRequest): Promise<Feedback> {
        try {
            const response = await api.post<{data: Feedback}>('/api/admin/feedbacks', feedback);
            return response.data;
        } catch (error) {
            console.error('Error creating feedback:', error);
            throw error;
        }
    }

    async update(id: number, feedback: FeedbackCreateRequest): Promise<Feedback> {
        try {
            const response = await api.put<{data: Feedback}>(`/api/admin/feedbacks/${id}`, feedback);
            return response.data;
        } catch (error) {
            console.error('Error updating feedback:', error);
            throw error;
        }
    }

    async delete(id: number): Promise<void> {
        try {
            await api.delete(`/api/admin/feedbacks/${id}`);
        } catch (error) {
            console.error('Error deleting feedback:', error);
            throw error;
        }
    }

    async reorder(feedbacks: Feedback[]): Promise<void> {
        try {
            await api.put('/api/admin/feedbacks/reorder', feedbacks);
        } catch (error) {
            console.error('Error reordering feedbacks:', error);
            throw error;
        }
    }
}

export default new FeedbackService();
